var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgItalianFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 1500,
  height: 1000,
  viewBox: "0 0 3 2"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 2,
  fill: "#009246"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 2,
  x: 1,
  fill: "#fff"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 1,
  height: 2,
  x: 2,
  fill: "#ce2b37"
})));
export { SvgItalianFlag as ReactComponent };
export default __webpack_public_path__ + "3094e87722c26e87e1ffa034fb4bfa11.svg";